import { db } from '@/mocks/db';
export async function findJpPaySlipIdForPeriod(period: string): Promise<string | null> {
  const slips = await db.paySlips.where('period').equals(period).toArray();
  const jp = slips.find(s => s.countryCode === 'JP');
  return jp?.id ?? null;
}

/** 従業員に紐づく最新の給与サマリ月（YYYY-MM の降順先頭） */
export async function getEmployeeLatestPaySlipPeriodFromDb(employeeId: string): Promise<{
  year: number;
  month: number;
} | null> {
  const summaries = await db.employeePaySlipSummaries.where('employeeId').equals(employeeId).toArray();
  if (summaries.length === 0) return null;
  const sorted = [...summaries].sort((a, b) => b.period.localeCompare(a.period));
  const [y, m] = sorted[0].period.split('-').map(Number);
  return {
    year: y,
    month: m
  };
}